import { render, staticRenderFns } from "./EntityTagModal.vue?vue&type=template&id=dddb8238&"
import script from "./EntityTagModal.vue?vue&type=script&lang=js&"
export * from "./EntityTagModal.vue?vue&type=script&lang=js&"
import style0 from "./EntityTagModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports